import axios from "axios";
import { API_END_POINT } from "../../../constants/api";

export function addyarnReceived(yarnRecievedData) {
  let authToken = localStorage.getItem("usertoken");
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  const body = JSON.stringify(yarnRecievedData);
  let response = axios.post(
    `${API_END_POINT}/contract/yarn-issuence/yarn-received`,
    body,
    config
  );

  return response;
}

export function addyarnReturn(yarnReturnData) {
  let authToken = localStorage.getItem("usertoken");
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  const body = JSON.stringify(yarnReturnData);
  let response = axios.post(
    `${API_END_POINT}/contract/yarn-issuence/yarn-return`,
    body,
    config
  );

  return response;
}

export function getYarnReceived(params) {
  let authToken = localStorage.getItem("usertoken");
  let { contractId, limit } = params;

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  let response = axios.get(
    `${API_END_POINT}/contract/yarn-issuence/get/yarn-received/${contractId}/limit=${limit}`,
    config
  );

  return response;
}

export function getYarnReturn(params) {
  let authToken = localStorage.getItem("usertoken");
  let { contractId, limit } = params;

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  let response = axios.get(
    `${API_END_POINT}/contract/yarn-issuence/get/yarn-return/${contractId}/limit=${limit}`,
    config
  );

  return response;
}

export function deleteYarnReceived(yarnReceivedId) {
  let authToken = localStorage.getItem("usertoken");
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  let response = axios.delete(
    `${API_END_POINT}/yarn-issuence/delete/yarn-received/${yarnReceivedId}`,
    config
  );

  return response;
}

export function deleteYarnReturn(yarnReturnId) {
  let authToken = localStorage.getItem("usertoken");
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  let response = axios.delete(
    `${API_END_POINT}/yarn-issuence/delete/yarn-return/${yarnReturnId}`,
    config
  );

  return response;
}

export function updateYarnReceived(params) {
  let authToken = localStorage.getItem("usertoken");
  let { yarnReceivedIdToEdit, updatedValue } = params;

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  const body = JSON.stringify(updatedValue);

  let response = axios.put(
    `${API_END_POINT}/contract/yarn-issuence/edit/yarn-received/${yarnReceivedIdToEdit}`,
    body,
    config
  );

  return response;
}

export function updateYarnReturn(params) {
  let authToken = localStorage.getItem("usertoken");
  let { yarnReturnIdToEdit, updatedValue } = params;

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  const body = JSON.stringify(updatedValue);

  let response = axios.put(
    `${API_END_POINT}/contract/yarn-issuence/edit/yarn-return/${yarnReturnIdToEdit}`,
    body,
    config
  );

  return response;
}

export function getCompanyYarnHistory(companyId, limit = 500) {
  let authToken = localStorage.getItem("usertoken");
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  return axios.get(
    `${API_END_POINT}/contract/yarn-issuence/get/company/${companyId}/limit=${limit}`,
    config
  );
}
